import { Header1 } from "./Header1";
import { Footer } from "./Footer";
import AuthContext from "../../Context/auth/AuthContext";
import { useContext } from "react";
import FloatingWhatsAppButton from "./FloatingWhatsappIcon";
import BirthdayEffects from "../BirthdayEffects"; // Asegúrate de que la ruta y exportación estén correctas
import moment from "moment";

// Layout con sesión iniciada
const UserLayout = ({ children, showBirthday }) => (
  <>
    <header className='header'>
      <Header1 />
    </header>
    <main className='content'>
      {showBirthday && <BirthdayEffects name={showBirthday.name} />}
      {children}
    </main>
    <footer className='footer'>
      <Footer />
    </footer>
    <FloatingWhatsAppButton />
  </>
);

// Layout sin sesión iniciada
const NoAuthLayout = ({ children }) => (
  <>
    <header className='header'>
      <Header1 />
    </header>
    <main className='content'>{children}</main>
    <footer className='footer'>
      <Footer />
    </footer>
    <FloatingWhatsAppButton />
  </>
);

// Layout principal
const Layout = ({ children }) => {
  const { usuario, loading } = useContext(AuthContext);
  // console.log(usuario, "el usuario");

  if (loading) return null;

  const esCumpleaños = () => {
    if (!usuario?.birthdate || usuario.birthdate === null) return false;

    const today = moment();
    const birthday = moment(usuario.birthdate, "DD/MM/YYYY");
    if (!birthday.isValid()) {
      console.log("Fecha no válida:", usuario.birthdate);
      return false;
    }

    return (
      today.date() === birthday.date() && today.month() === birthday.month() // nota: mes en moment va de 0 a 11 igual que en dayjs
    );
  };

  // Verificar si se debe mostrar el cumpleaños
  const showBirthday = esCumpleaños() ? { name: usuario.name } : null;

  return usuario ? (
    <UserLayout showBirthday={showBirthday}>{children}</UserLayout>
  ) : (
    <NoAuthLayout>{children}</NoAuthLayout>
  );
};

export default Layout;
